export const theme = {
  colors: {
    bg: '#0b1220',
    surface: 'rgba(255, 255, 255, 0.06)',
    surfaceStrong: 'rgba(255, 255, 255, 0.10)',
    text: '#e6edf3',
    muted: 'rgba(230, 237, 243, 0.72)',
    border: 'rgba(255, 255, 255, 0.12)',
    primary: '#6ee7ff',
    primary2: '#a78bfa'
  },
  radii: {
    md: '14px',
    lg: '18px'
  },
  shadow: {
    card: '0 10px 30px rgba(0, 0, 0, 0.35)'
  },
  container: {
    maxWidth: '1080px'
  }
};
